// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__NgHfq","footer":"ChangeClinic_footer__3de2g"};